import { render, staticRenderFns } from "./progress.vue?vue&type=template&id=452bc978&scoped=true"
import script from "./progress.vue?vue&type=script&lang=js"
export * from "./progress.vue?vue&type=script&lang=js"
import style0 from "./progress.vue?vue&type=style&index=0&id=452bc978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bc978",
  null
  
)

export default component.exports